import styled from 'styled-components';

import { GridContainer } from '@xing-com/grid';
import { mediaConfined } from '@xing-com/layout-tokens';
import { spaceXL, spaceXXL } from '@xing-com/tokens';
import { Meta } from '@xing-com/typography';

export const StyledMainGridContainer = styled(GridContainer)`
  gap: 0;
`;

export const StyledMeta = styled(Meta)`
  padding-top: ${spaceXL};

  @media ${mediaConfined} {
    padding-top: ${spaceXXL};
  }
`;
